import Evented from "@ember/object/evented";
import Service from "@ember/service";
export default class AppEvents extends Service.extend(Evented) {}